import { render, staticRenderFns } from "./AppVersion.vue?vue&type=template&id=2a0d0944&scoped=true&"
var script = {}
import style0 from "./AppVersion.vue?vue&type=style&index=0&id=2a0d0944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0d0944",
  null
  
)

export default component.exports